import React, { useEffect, useState } from 'react';
import { Outlet, useLocation, useNavigate } from 'react-router';
import { Tabs } from '@sede-enterprise/shell-ds-react-framework';
import { PositionsContainer } from './style';
import { NUMBERS } from '../../../constants/Common';

const BALANCES_TAB = 'balances';

const renderRouteLabel = (label: string, route: string) => (
  <a
    href={route}
    onClick={(event) => event.preventDefault()}
    style={{ color: 'inherit', textDecoration: 'none' }}
  >
    {label}
  </a>
);

const Positions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [activeTab, setActiveTab] = useState<string>(BALANCES_TAB);

  useEffect(() => {
    const pathSegments = location.pathname.split('/');
    const subTab = pathSegments[NUMBERS.THREE] || BALANCES_TAB;
    setActiveTab(subTab);
  }, [location]);

  const handleTabChange = (tabKey: string) => {
    setActiveTab(tabKey);
    navigate(`/new-genesis/positions/${tabKey}`);
  };

  const tabs = [
    {
      key: BALANCES_TAB,
      label: renderRouteLabel('Balances', '/new-genesis/positions/balances'),
    },
    {
      key: 'market-position',
      label: renderRouteLabel('Market Position', '/new-genesis/positions/market-position'),
    },
    {
      key: 'contract-view',
      label: renderRouteLabel('Contract View', '/new-genesis/positions/contract-view'),
    },
  ];

  return (
    <PositionsContainer>
      <Tabs className='sub-tab' activeKey={activeTab} onChange={handleTabChange} items={tabs} />
      <div className='content'>
        <Outlet />
      </div>
    </PositionsContainer>
  );
};

export default Positions;
